import React, { useState, useEffect } from 'react';
import apiClient from '../services/apiService';
import securityLogger from '../utils/securityLogger';
import './About.css';

function About() {
  const [aboutData, setAboutData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchAboutData();
  }, []);

  const fetchAboutData = async () => {
    try {
      securityLogger.debug('Fetching about data', { url: apiClient.defaults.baseURL + '/about' });
      const response = await apiClient.get('/about');
      securityLogger.debug('About data received', { status: response.status, hasData: !!response.data });
      setAboutData(response.data);
    } catch (err) {
      securityLogger.error('About fetch error', {
        message: err.message,
        status: err.response?.status,
        hasResponse: !!err.response,
        hasConfig: !!err.config
      });
      setError('Failed to load about information');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="about-container">Loading...</div>;
  }

  if (error) {
    return <div className="about-container">Error: {error}</div>;
  }

  return (
    <div className="about-container">
      <div className="about-content">
        <h2>About {aboutData?.company_name}</h2>
        
        <div className="about-section">
          <p>{aboutData?.description}</p>
        </div>

        <div className="about-section">
          <h3>Founder</h3>
          <p>{aboutData?.founder}</p>
          <p>{aboutData?.background}</p>
        </div>

        <div className="about-section">
          <h3>GIS Focus</h3>
          <p>{aboutData?.gis_focus}</p>
        </div>

        <div className="about-section">
          <h3>Contact Info</h3>
          <p>{aboutData?.contact}</p>
        </div>
      </div>
    </div>
  );
}

export default About;
